import React, { useState, useEffect } from 'react';
import {
  Award,
  TrendingUp,
  Image as ImageIcon,
  Edit2,
  Trash2,
  Plus,
  Upload,
  X,
  Globe,
  Check,
  Pencil,
  Star,
  BarChart3,
  CheckCircle,
  AlertCircle,
  Calendar,
  FileText,
  Megaphone,
  Sparkles,
  Loader2
} from 'lucide-react';
import './JournalMetrics.css';
// import CallForPapersSidebar from '../../components/CommonWidgets/CallForPapersSidebar/CallForPapersSidebar';
import { ApiUrl, BaseUrl } from '../API/ApiUrl';
import Toast from "../components/Toast/Toast";
import Swal from 'sweetalert2';
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";

const JournalMetrics = () => {
  // State for Indexing section
  const [indexingImages, setIndexingImages] = useState([]);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success"
  });
  // State for Impact Factor section
  const [impactImages, setImpactImages] = useState([]);

  // State for Call for Papers section
  const [callForPapers, setCallForPapers] = useState([]);

  const [showIndexingForm, setShowIndexingForm] = useState(false);
  const [showImpactForm, setShowImpactForm] = useState(false);
  const [showCallForPapersForm, setShowCallForPapersForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    image: null,
    alt: '',
    value: '',
    title: '',
    deadline: '',
    status: 'active'
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [inputText, setInputText] = useState("");
  const [displayText, setDisplayText] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAdd = () => {
    if (!inputText.trim()) return;
    setDisplayText(inputText);
    setInputText("");
  };

  const handleEditText = () => {
    setInputText(displayText);
    setIsEditing(true);
  };

  const handleUpdate = () => {
    setDisplayText(inputText);
    setInputText("");
    setIsEditing(false);
  };

  const handleCancel = () => {
    setInputText("");
    setIsEditing(false);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 5) {
      setToast({
        show: true,
        message: "Maximum 5 images allowed",
        type: "error"
      });

      e.target.value = null;
      return;
    }

    if (files.length > 0) {
      setSelectedFile(files); // store array

      setFormData({
        ...formData,
        images: files
      });
    }
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value
  //   });
  // };

  // const validateForm = (section) => {
  //   if (!selectedFile && !editingItem) {
  //     setErrorMessage('Please select an image');
  //     return false;
  //   }
  //   if (section === 'impact' && !formData.value) {
  //     setErrorMessage('Please enter impact factor value');
  //     return false;
  //   }
  //   if (section === 'callforpapers') {
  //     if (!formData.title) {
  //       setErrorMessage('Please enter call for papers title');
  //       return false;
  //     }
  //     if (!formData.deadline) {
  //       setErrorMessage('Please select deadline date');
  //       return false;
  //     }
  //   }
  //   return true;
  // };

  // define function OUTSIDE useEffect
  const fetchAllSections = async () => {

    const startTime = performance.now();

    try {

      const [indexingRes, impactRes, callRes] = await Promise.all([
        fetch(`${ApiUrl}/journal-metrics/indexing`),
        fetch(`${ApiUrl}/journal-metrics/impact_factor`),
        fetch(`${ApiUrl}/journal-metrics/call_for_papers`)
      ]);

      const [indexingData, impactData, callData] = await Promise.all([
        indexingRes.json(),
        impactRes.json(),
        callRes.json()
      ]);

      const endTime = performance.now();

      console.log(`All metrics APIs took ${(endTime - startTime).toFixed(2)} ms`);

      if (indexingRes.ok) setIndexingImages(indexingData);
      if (impactRes.ok) setImpactImages(impactData);
      if (callRes.ok) setCallForPapers(callData);

    } catch (error) {
      setToast({
        show: true,
        message: "Failed to fetch images",
        type: "error"
      });
    }
  };

  useEffect(() => {
    fetchAllSections();
  }, []);

  const handleImageUpload = async (e, sectionType) => {
    e.preventDefault();

    const token = localStorage.getItem("adminToken");

    setLoading(true); // start loader

    try {
      const formData = new FormData();
      formData.append("sectionType", sectionType);

      if (selectedFile && selectedFile.length > 0) {
        selectedFile.forEach((file) => {
          formData.append("images", file);
        });
      }
      let response;

      if (editingItem) {
        response = await fetch(`${ApiUrl}/journal-metrics/${editingItem.id}`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: formData
        });
      } else {

        if (!selectedFile || selectedFile.length === 0) {
          setToast({
            show: true,
            message: "Please select an image",
            type: "error"
          });
          setLoading(false);
          return;
        }

        response = await fetch(`${ApiUrl}/journal-metrics`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: formData
        });
      }

      const data = await response.json();

      if (!response.ok) {
        setToast({
          show: true,
          message: data.message,
          type: "error"
        });
        setLoading(false);
        return;
      }

      setToast({
        show: true,
        message: editingItem
          ? "Image updated successfully 🎉"
          : "Image uploaded successfully 🎉",
        type: "success"
      });

      setSelectedFile(null);
      setEditingItem(null);
      resetForm();

      fetchAllSections();
    } catch (error) {
      console.error(error);
      setToast({
        show: true,
        message: "Server error",
        type: "error"
      });
    }

    setLoading(false); // stop loader
  };

  const handleEdit = (item, section) => {
    setEditingItem(item);
    setSelectedFile(null); // clear old file

    if (section === "indexing") {
      setShowIndexingForm(true);
    } else if (section === "impact_factor") {
      setShowImpactForm(true);
    } else if (section === "call_for_papers") {
      setShowCallForPapersForm(true);
    }
  };
  const handleDelete = (id, section) => {

    Swal.fire({
      title: "Are you sure?",
      text: "This item will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("adminToken");

          const response = await fetch(
            `${ApiUrl}/journal-metrics/${id}`,
            {
              method: "DELETE",
              headers: {
                "Authorization": `Bearer ${token}`
              }
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.message || "Delete failed");
          }

          return data;

        } catch (error) {
          Swal.showValidationMessage(
            `Request failed: ${error.message}`
          );
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {

      if (result.isConfirmed) {

        //  Remove from UI only after API success
        if (section === "indexing") {
          setIndexingImages(prev =>
            prev.filter(item => item.id !== id)
          );
        } else if (section === "impact_factor") {
          setImpactImages(prev =>
            prev.filter(item => item.id !== id)
          );
        } else if (section === "call_for_papers") {
          setCallForPapers(prev =>
            prev.filter(item => item.id !== id)
          );
        }

        setToast({
          show: true,
          message: "Image deleted successfully 🎉",
          type: "success"
        });
      }
    });
  };

  const resetForm = () => {
    setFormData({
      name: '',
      image: null,
      alt: '',
      value: '',
      title: '',
      deadline: '',
      status: 'active'
    });
    setSelectedFile(null);
    setEditingItem(null);
    setShowIndexingForm(false);
    setShowImpactForm(false);
    setShowCallForPapersForm(false);
    setErrorMessage('');
  };

  return (
    <div className="journal-metrics-page">
      {/* Header */}
      <div className="page-header">
        <div className="title-section">
          <Award size={40} className="title-icon" />
          <div>
            <h1 className="page-title">Journal Metrics</h1>
            <p className="page-subtitle">Manage indexing, impact factor, and call for papers</p>
          </div>
        </div>
      </div>

      {/* Success/Error Messages */}
      {successMessage && (
        <div className="alert success">
          <CheckCircle size={16} />
          <span>{successMessage}</span>
        </div>
      )}

      {errorMessage && (
        <div className="alert error">
          <AlertCircle size={16} />
          <span>{errorMessage}</span>
        </div>
      )}

      <div className="metrics-grid three-columns">
        <div className="metric-section">
          <div className="section-header">
            <div className="section-title">
              <Globe size={20} className="section-icon" />
              <h2>Indexing</h2>
            </div>
            {!showIndexingForm && (
              <button
                className="btn-add"
                onClick={() => {
                  resetForm();
                  setShowIndexingForm(true);
                }}
              >
                <Plus size={16} />
                <span>Add Image</span>
              </button>
            )}
          </div>

          {showIndexingForm && (
            <div className="upload-form">
              <form onSubmit={(e) => handleImageUpload(e, "indexing")}>
                <div className="form-group">
                  <label htmlFor="indexing-image">
                    <ImageIcon size={14} />
                    <span>Choose Image <span className="required">*</span></span>
                  </label>
                  <input
                    type="file"
                    id="indexing-image"
                    accept=".png,.jpg,.jpeg"
                    multiple
                    onChange={handleFileChange}
                    className="file-input"
                    required={!editingItem}
                  />
                  {selectedFile && (
                    <span className="file-name">{selectedFile.name}</span>
                  )}
                  {editingItem && !selectedFile && (
                    <span className="file-name">
                      Existing: {editingItem.image_name}
                    </span>
                  )}
                </div>

                <div className="form-actions">
                  <button type="button" className="btn-cancel" onClick={resetForm} disabled={loading}>
                    Cancel
                  </button>
                  <button type="submit" className="btn-save" disabled={loading}>

                    {loading ? (
                      <>
                        <Loader2 size={16} className="spin-icon" />
                        <span>{editingItem ? "Updating..." : "Saving..."}</span>
                      </>
                    ) : (
                      <>
                        <Upload size={14} />
                        <span>{editingItem ? "Update" : "Save"}</span>
                      </>
                    )}

                  </button>
                </div>
              </form>
            </div>
          )}

          <div className="images-grid">
            {indexingImages.length === 0 ? (
              <div className="no-data-message">
                No images uploaded
              </div>
            ) : (
              indexingImages.map((item) => {
                const cleanPath = item.image_path.replace(/\\/g, "/");
                const imageUrl = `${BaseUrl}/${cleanPath}`;

                // console.log("Image Path from DB:", item.image_path);
                // console.log("Final Image URL:", imageUrl);

                return (
                  <div key={item.id} className="image-card">
                    <div className="image-preview">
                      <img
                        loading='lazy'

                        src={imageUrl}
                        alt={item.image_name}
                        onError={(e) => {
                          console.error("Image failed to load:", imageUrl);
                        }}
                      />
                    </div>

                    <div className="image-info">
                      <h4>{item.image_name}</h4>
                      <span className="upload-date">
                        {item.created_at
                          ? new Date(item.created_at)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric"
                            })
                            .replace(/\//g, "-")
                          : "-"}
                      </span>
                    </div>

                    <div className="image-actions">
                      <button
                        className="action-btn edit"
                        onClick={() => handleEdit(item, "indexing")}
                      >
                        <Edit2 size={14} />
                      </button>

                      <button
                        className="action-btn delete"
                        onClick={() => handleDelete(item.id, "indexing")}
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          <div className="section-stats">
            <div className="stat">
              <ImageIcon size={14} />
              <span>{indexingImages.length} Images</span>
            </div>

          </div>
        </div>

        <div className="metric-section">
          <div className="section-header">
            <div className="section-title">
              <TrendingUp size={20} className="section-icon" />
              <h2>Impact Factor</h2>
            </div>
            {!showImpactForm && (
              <button
                className="btn-add"
                onClick={() => {
                  resetForm();
                  setShowImpactForm(true);
                }}
              >
                <Plus size={16} />
                <span>Add Image</span>
              </button>
            )}
          </div>

          {/* Impact Factor Form */}
          {showImpactForm && (
            <div className="upload-form">
              <form onSubmit={(e) => handleImageUpload(e, "impact_factor")}>
                <div className="form-group">
                  <label htmlFor="impact-image">
                    <ImageIcon size={14} />
                    <span>Choose Image <span className="required">*</span></span>
                  </label>
                  <input
                    type="file"
                    id="impact-image"
                    accept=".png,.jpg,.jpeg"
                    multiple
                    onChange={handleFileChange}
                    className="file-input"
                    required={!editingItem}
                  />
                  {selectedFile && (
                    <span className="file-name">{selectedFile.name}</span>
                  )}
                  {editingItem && !selectedFile && (
                    <span className="file-name">
                      Existing: {editingItem.image_name}
                    </span>
                  )}
                </div>



                <div className="form-actions">
                  <button type="button" className="btn-cancel" onClick={resetForm} disabled={loading}>
                    Cancel
                  </button>
                  <button type="submit" className="btn-save" disabled={loading}>

                    {loading ? (
                      <>
                        <Loader2 size={16} className="spin-icon" />
                        <span>{editingItem ? "Updating..." : "Saving..."}</span>
                      </>
                    ) : (
                      <>
                        <Upload size={14} />
                        <span>{editingItem ? "Update" : "Save"}</span>
                      </>
                    )}

                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Impact Factor Images Grid */}
          <div className="images-grid">
            {impactImages.length === 0 ? (
              <div className="no-data-message">
                No images uploaded
              </div>
            ) : (
              impactImages.map((item) => {
                const cleanPath = item.image_path.replace(/\\/g, "/");
                const imageUrl = `${BaseUrl}/${cleanPath}`;

                // console.log("Image Path from DB:", item.image_path);
                // console.log("Final Image URL:", imageUrl);

                return (
                  <div key={item.id} className="image-card">
                    <div className="image-preview">
                      <img
                        loading='lazy'

                        src={imageUrl}
                        alt={item.image_name}
                        onError={(e) => {
                          console.error("Image failed to load:", imageUrl);
                        }}
                      />
                    </div>

                    <div className="image-info">
                      <h4>{item.image_name}</h4>
                      <span className="upload-date">
                        {item.created_at
                          ? new Date(item.created_at)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric"
                            })
                            .replace(/\//g, "-")
                          : "-"}
                      </span>
                    </div>

                    <div className="image-actions">
                      <button
                        className="action-btn edit"
                        onClick={() => handleEdit(item, "impact_factor")}
                      >
                        <Edit2 size={14} />
                      </button>

                      <button
                        className="action-btn delete"
                        onClick={() => handleDelete(item.id, "impact_factor")}
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Stats for Impact Factor */}
          <div className="section-stats">
            <div className="stat">
              <ImageIcon size={14} />
              <span>{impactImages.length} Images</span>
            </div>

          </div>
        </div>

        {/* Call for Papers Section */}
        <div className="metric-section">
          <div className="section-header">
            <div className="section-title">
              <Megaphone size={20} className="section-icon" />
              <h2>Call for Papers</h2>
            </div>
            {!showCallForPapersForm && (
              <button
                className="btn-add"
                onClick={() => {
                  resetForm();
                  setShowCallForPapersForm(true);
                }}
              >
                <Plus size={16} />
                <span>Add New</span>
              </button>
            )}
          </div>

          {/* Call for Papers Form */}
          {showCallForPapersForm && (
            <div className="upload-form">
              <form onSubmit={(e) => handleImageUpload(e, "call_for_papers")}>
                <div className="form-group">
                  <label htmlFor="cfp-image">
                    <ImageIcon size={14} />
                    <span>Choose Image <span className="required">*</span></span>
                  </label>
                  <input
                    type="file"
                    id="cfp-image"
                    accept=".png,.jpg,.jpeg"
                    multiple
                    onChange={handleFileChange}
                    className="file-input"
                    required={!editingItem}
                  />
                  {selectedFile && (
                    <span className="file-name">{selectedFile.name}</span>
                  )}
                  {editingItem && !selectedFile && (
                    <span className="file-name">
                      Existing: {editingItem.image_name}
                    </span>
                  )}
                </div>



                <div className="form-actions">
                  <button type="button" className="btn-cancel" onClick={resetForm} disabled={loading}>
                    Cancel
                  </button>
                  <button type="submit" className="btn-save" disabled={loading}>

                    {loading ? (
                      <>
                        <Loader2 size={16} className="spin-icon" />
                        <span>{editingItem ? "Updating..." : "Saving..."}</span>
                      </>
                    ) : (
                      <>
                        <Upload size={14} />
                        <span>{editingItem ? "Update" : "Save"}</span>
                      </>
                    )}

                  </button>
                </div>
              </form>
            </div>
          )}

          {/* Call for Papers Grid */}
          <div className="images-grid">
            {callForPapers.length === 0 ? (
              <div className="no-data-message">
                No images uploaded
              </div>
            ) : (
              callForPapers.map((item) => {
                const cleanPath = item.image_path.replace(/\\/g, "/");
                const imageUrl = `${BaseUrl}/${cleanPath}`;

                // console.log("Image Path from DB:", item.image_path);
                // console.log("Final Image URL:", imageUrl);

                return (
                  <div key={item.id} className="image-card">
                    <div className="image-preview">
                      <img
                        loading='lazy'
                        src={imageUrl}
                        alt={item.image_name}
                        onError={(e) => {
                          console.error("Image failed to load:", imageUrl);
                        }}
                      />
                    </div>

                    <div className="image-info">
                      <h4>{item.image_name}</h4>
                      <span className="upload-date">
                        {item.created_at
                          ? new Date(item.created_at)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric"
                            })
                            .replace(/\//g, "-")
                          : "-"}
                      </span>
                    </div>

                    <div className="image-actions">
                      <button
                        className="action-btn edit"
                        onClick={() => handleEdit(item, "call_for_papers")}
                      >
                        <Edit2 size={14} />
                      </button>

                      <button
                        className="action-btn delete"
                        onClick={() => handleDelete(item.id, "call_for_papers")}
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
          <div className="section-stats">
            <div className="stat">
              <ImageIcon size={14} />
              <span>{callForPapers.length} Images</span>
            </div>

          </div>

        </div>

        {/* <CallForPapersSidebar /> */}

      </div>


      {toast.show && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() =>
            setToast(prev => ({ ...prev, show: false }))
          } />
      )}
    </div>
  );
};

export default JournalMetrics;